import { jsxs as i, jsx as e } from "react/jsx-runtime";
import { Title as m } from "./style.js";
import { Icon as p } from "../../../../components/Icon/index.js";
import { Xmark as c } from "@pelando/fontawesome/icons";
import { useDropdownContext as l } from "../../../../contexts/Dropdown/context.js";
function w({
  children: o,
  closeIconLabel: r = "Fechar dropdown",
  ...t
}) {
  const { closeDropdown: n } = l();
  return /* @__PURE__ */ i(m, { ...t, children: [
    o,
    /* @__PURE__ */ e(
      p,
      {
        icon: c,
        onClick: n,
        "aria-label": r,
        role: "button"
      }
    )
  ] });
}
export {
  w as DropdownListTitle
};
